var _text, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElementWordmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 48",
    role: "img",
    "aria-label": "Berlin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 36,
    fontFamily: "Inter, Arial, Helvetica, sans-serif",
    fontSize: 32,
    fontWeight: 700,
    fill: "#ffffff",
    letterSpacing: -0.5
  }, "berlin")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 32,
    r: 7,
    fill: "#f07167"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementWordmarkWhite);
export default __webpack_public_path__ + "static/media/element-wordmark-white.c8d9c49bf888805ec9d7bbeac6d66d38.svg";
export { ForwardRef as ReactComponent };